export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标项目名称：",
            type: "input",
            value: "tenderPrjName",
            width: "100%",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标项目名称",
              trigger: "blur"
            }
          },
          {
            label: "招标公告编号：",
            type: "slot",
            value: "announcementId",
            slotName: "announcementId",
            disabled: true,
            width: "100%",
            rule: {
              required: true,
              message: "请选择招标公告",
              trigger: "blur"
            }
          },
          {
            label: "预审公示开始时间：",
            type: "input",
            value: "prequalificationStartDate",
            tipContent: "资格预审公示开始时间和截止时间由首次终审通过时间根据所填写的公示天数自动生成，不能手动填写。",
            disabled: true,
            rule: {
              required: false,
              message: "请填写预审公示开始时间",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "资格预审评审小组成员名单",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "formList",
            slotName: "memberList",
          },
        ]
      },
      {
        title: "资格预审信息",
        name: "5",
        icon: "",
        tipsList: [
          {
            text: "（1）通知书发出时间和通知书回复截止时间由确认资格预审的申请人通过时所填写的通知书回复天数自动生成，不能手动填写。"
          },
          {
            text: "（2）招标人在资格预审合格通知书中载明的给予投标人确认参加投标的时间不应少于5日，且确认参加投标的截止时间应当在下载招标文件截止时间前。"
          },
          {
            type: "slot",
            slotName: "preMsgL",
          },
          {
            type: "slot",
            slotName: "preMsgF",
          },
        ],
        formConfigList: [

        ]
      },
      {
        title: "资格预审情况",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "资格预审情况：",
            value: "prequalificationCondition",
            type: "textarea",
            required: true,
            maxlength: 1300,
            // tip: "工程概况、抽取评审专家_ _人﹑项目资格预审文件下载_ _家﹑提交资格预审文件_ _家﹑签到_ _家﹑通过_ _家﹑不通过_ _家、评审及通过资格预审的方法和过程﹑资格预审未通过的原因及其他相关内容。",
            width: "100%;",
            minRows: "3",
            maxRows: "2",
            rule: {
              required: true,
              message: "请填写资格预审情况",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "备注信息",
        name: "7",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            width: "100%;",
            required: true,
            maxlength: 1300,
            minRows: "3",
            maxRows: "2",
            rule: {
              required: false,
              message: "请填写备注",
              trigger: "blur"
            }
          },
        ]
      },
      // {
      //   title: "资格预审评审信息",
      //   name: "8",
      //   icon: "",
      //   formConfigList: [
      //     {
      //       label: "工程规模指标：",
      //       type: "input",
      //       value: "municipalScale",
      //       disabled: true,
      //       maxlength: 500,
      //       rule: {
      //         required: false,
      //         message: "请填写工程规模指标",
      //         trigger: "blur"
      //       }
      //     },
      //     {
      //       label: "合格投标人数量：",
      //       type: "input",
      //       value: "quotaNum",
      //       disabled: true,
      //       maxlength: 10,
      //       rule: {
      //         required: false,
      //         message: "请填写合格投标人数量",
      //         trigger: "blur"
      //       }
      //     },
      //     {
      //       label: "单位工程数（个）：",
      //       type: "input",
      //       value: "unitProjectNum",
      //       disabled: true,
      //       maxlength: 10,
      //       rule: {
      //         required: false,
      //         message: "请填写单位工程数（个）",
      //         trigger: "blur"
      //       }
      //     },
      //     {
      //       label: "评审地点：",
      //       type: "input",
      //       value: "reviewAdd",
      //       disabled: true,
      //       maxlength: 100,
      //       rule: {
      //         required: false,
      //         message: "请填写评审地点",
      //         trigger: "blur"
      //       }
      //     },
      //     {
      //       label: "评审时间：",
      //       value: "reviewDate",
      //       type: "date",
      //       dateType: "datetime",
      //       required: true,
      //       clearable: true,
      //       disabled: true,
      //       valueFormat: "yyyy-MM-dd HH:mm:ss",
      //       rule: {
      //         required: false,
      //         message: "请选择评审时间",
      //         trigger: "change"
      //       }
      //     },
      //     {
      //       label: "评审程序和内容：",
      //       value: "prequalificationContent",
      //       type: "textarea",
      //       tip: "预审结果公示截止后，由招标人/招标代理机构将资格预审评审小组成员名单和资格预审评审程序和内容录入到本平台。",
      //       width: "100%;",
      //       required: true,
      //       disabled: true,
      //       maxlength: 2500,
      //       minRows: "3",
      //       maxRows: "2",
      //       rule: {
      //         required: false,
      //         message: "请填写评审程序和内容",
      //         trigger: "blur"
      //       }
      //     },
      //   ]
      // },
      {
        title: "其他",
        name: "10",
        icon: "",
        formConfigList: [
          // {
          //   label: "历史核验记录：",
          //   type: "slot",
          //   slotName: "state",
          // },
          {
            label: "招标人意见：",
            value: "tenderOpinion",
            type: "textarea",
            width: "100%",
            required: true,
            maxlength: 100,
            minRows: "3",
            maxRows: "2",
            disabled: true,
          },
        ]
      },
    ];
  }
}
